(function () {
  var mappyListTouched = false;
  var mapActiveTimer;

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.store-list-button.show-on-mobile')) return;

    if (document.body.classList.contains('leaflock-mappy-list-collapsed')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    mappyListTouched = true;
    document.body.classList.remove('leaflock-mappy-list-collapsed');
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.leaflock-map-activate')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setMappyMapActive(true);
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-leaflock-shop-quick]');
    if (!trigger) return;

    var form = trigger.closest('form');
    if (!form) return;

    event.preventDefault();

    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : '';
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!quantityInput && form.id) {
      quantityInput = document.querySelector('[name="quantity"][form="' + form.id + '"]');
    }

    if (!quantityInput) {
      var productInfo = trigger.closest('.hdt-product-info__list, .hdt-product-info, .hdt-product__info-container, .hdt-main-product');
      quantityInput = productInfo ? productInfo.querySelector('[name="quantity"]') : null;
    }

    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!variantId) {
      form.requestSubmit();
      return;
    }

    if (!quantity || quantity < 1) {
      quantity = 1;
    }

    window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(quantity) + '?checkout';
  }, true);

  function collapseMappyStoreListOnMobile() {
    if (!window.matchMedia('(max-width: 749px)').matches || mappyListTouched) {
      document.body.classList.remove('leaflock-mappy-list-collapsed');
      return;
    }

    var list = document.querySelector('#bss-map-search-box');
    if (list) {
      document.body.classList.add('leaflock-mappy-list-collapsed');
    }
  }

  function bindMappyStoreListButton() {
    var button = document.querySelector('.store-list-button.show-on-mobile');
    if (!button || button.dataset.leaflockBound === 'true') return;

    button.dataset.leaflockBound = 'true';
    button.addEventListener('pointerdown', function () {}, true);
  }

  function tuneMappyStoreList() {
    bindMappyStoreListButton();
    collapseMappyStoreListOnMobile();
    tuneMappyMapTouch();
  }

  function setMappyMapActive(active) {
    document.body.classList.toggle('leaflock-mappy-map-active', active);
    document.body.classList.toggle('leaflock-mappy-map-passive', !active);

    if (mapActiveTimer) {
      window.clearTimeout(mapActiveTimer);
    }

    if (active) {
      mapActiveTimer = window.setTimeout(function () {
        setMappyMapActive(false);
      }, 12000);
    }
  }

  function tuneMappyMapTouch() {
    var map = document.querySelector('#store-locator-page-parent');
    if (!map) return;

    if (!map.querySelector('.leaflock-map-activate')) {
      var overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'leaflock-map-activate';
      overlay.textContent = 'Tap to use map';
      map.appendChild(overlay);
    }

    if (window.matchMedia('(max-width: 749px)').matches) {
      if (!document.body.classList.contains('leaflock-mappy-map-active')) {
        document.body.classList.add('leaflock-mappy-map-passive');
      }
    } else {
      document.body.classList.remove('leaflock-mappy-map-passive', 'leaflock-mappy-map-active');
    }

    if (map.dataset.leaflockMapBound === 'true') return;

    map.dataset.leaflockMapBound = 'true';
    map.addEventListener('pointerdown', function () {}, true);
  }

  function watchMappyStoreList() {
    var observer = new MutationObserver(tuneMappyStoreList);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    for (var i = 1; i <= 8; i += 1) {
      setTimeout(tuneMappyStoreList, i * 700);
    }
  }

  function formatMoney(cents) {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'AUD';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency
    }).format((Number(cents) || 0) / 100);
  }

  function updateSmartBundle(bundle) {
    var total = 0;

    bundle.querySelectorAll('[data-leaflock-smart-bundle-item]').forEach(function (item) {
      var checkbox = item.querySelector('[data-leaflock-smart-bundle-check]');
      var selector = item.querySelector('[data-leaflock-smart-bundle-select]');
      var selected = selector && selector.options ? selector.options[selector.selectedIndex] : selector;
      var price = selected ? Number(selected.dataset.price || 0) : 0;
      var comparePrice = selected ? Number(selected.dataset.comparePrice || 0) : 0;
      var priceNode = item.querySelector('[data-leaflock-smart-bundle-price]');
      var compareNode = item.querySelector('[data-leaflock-smart-bundle-compare]');

      if (priceNode) priceNode.textContent = formatMoney(price);
      if (compareNode) {
        compareNode.textContent = comparePrice > price ? formatMoney(comparePrice) : '';
        compareNode.hidden = comparePrice <= price;
      }

      item.classList.toggle('is-unchecked', checkbox && !checkbox.checked);
      if (!checkbox || checkbox.checked) total += price;
    });

    var totalNode = bundle.querySelector('[data-leaflock-smart-bundle-total]');
    if (totalNode) totalNode.textContent = formatMoney(total);
  }

  function bindSmartBundle(bundle) {
    if (bundle.dataset.leaflockBound === 'true') return;
    bundle.dataset.leaflockBound = 'true';

    bundle.addEventListener('change', function () {
      updateSmartBundle(bundle);
    });

    bundle.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = bundle.querySelector('.leaflock-smart-bundle__button');
      var message = bundle.querySelector('[data-leaflock-smart-bundle-message]');
      var items = [];

      bundle.querySelectorAll('[data-leaflock-smart-bundle-item]').forEach(function (item) {
        var checkbox = item.querySelector('[data-leaflock-smart-bundle-check]');
        var selector = item.querySelector('[data-leaflock-smart-bundle-select]');
        if (checkbox && !checkbox.checked) return;
        if (!selector || !selector.value) return;

        items.push({
          id: Number(selector.value),
          quantity: 1
        });
      });

      if (!items.length) return;
      if (button) button.setAttribute('aria-busy', 'true');
      if (message) message.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      }).then(function () {
        if (message) message.textContent = window.LeafLockSmartBundleAdded || 'Selected products added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function () {
        if (message) message.textContent = window.LeafLockSmartBundleError || 'Something went wrong. Please try again.';
      }).finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
    });

    updateSmartBundle(bundle);
  }

  function initSmartBundles() {
    document.querySelectorAll('[data-leaflock-smart-bundle-form]').forEach(bindSmartBundle);
  }

  function getWishlistShareText(trigger) {
    var baseText = 'I built my LeafLock wishlist. Tagging @leaflockofficial and @leaflockstore for the wishlist draw.';
    var shareUrl = trigger.dataset.shareUrl || window.location.origin || window.location.href;
    var titles = Array.prototype.slice.call(document.querySelectorAll('.hdt-main-wishlist .hdt-card-product__title'))
      .map(function (title) {
        return title.textContent.trim().replace(/\s+/g, ' ');
      })
      .filter(Boolean);

    if (titles.length) {
      baseText += '\nMy wishlist picks: ' + titles.slice(0, 5).join(', ');
      if (titles.length > 5) baseText += ' +' + (titles.length - 5) + ' more';
    }

    return baseText + '\n' + shareUrl;
  }

  function enhanceWishlistSharingPanel() {
    var panel = document.querySelector('.leaflock-wishlist-social');
    if (!panel) return;

    var drawCopy = panel.querySelector('.leaflock-wishlist-draw-copy');
    if (drawCopy) {
      drawCopy.textContent = 'Screenshot your wishlist, post it to Instagram, Facebook or TikTok, tag @leaflockofficial and @leaflockstore, and keep the LeafLock link in your caption so we can find random wishlist draw entries.';
    }

    if (!panel.querySelector('.leaflock-wishlist-shot-card')) {
      var textWrap = panel.firstElementChild;
      if (textWrap) {
        var shotCard = document.createElement('div');
        shotCard.className = 'leaflock-wishlist-shot-card';
        shotCard.innerHTML = '<span>Screenshot-ready wishlist</span><small>Copy the caption, screenshot this wishlist page, then post and tag both LeafLock accounts so we can find your entry.</small>';
        textWrap.appendChild(shotCard);
      }
    }

    panel.querySelectorAll('[data-leaflock-wishlist-share], [data-leaflock-wishlist-copy]').forEach(function (trigger) {
      trigger.dataset.shareText = 'I built my LeafLock wishlist. Tagging @leaflockofficial and @leaflockstore for the wishlist draw.';
      trigger.dataset.shareUrl = window.location.origin || trigger.dataset.shareUrl || window.location.href;
      trigger.dataset.shareSuccess = 'Wishlist caption copied. Screenshot this page and tag both LeafLock accounts when you post.';
    });

    var actions = panel.querySelector('.leaflock-social-actions');
    if (actions && !actions.querySelector('[href*="leaflockofficial"]')) {
      var officialLink = document.createElement('a');
      officialLink.href = 'https://www.instagram.com/leaflockofficial/';
      officialLink.target = '_blank';
      officialLink.rel = 'noopener';
      officialLink.className = 'leaflock-social-link leaflock-social-link--ghost';
      officialLink.textContent = '@leaflockofficial';
      actions.appendChild(officialLink);
    }
  }

  function writeWishlistStatus(trigger, message) {
    var wrapper = trigger.closest('.leaflock-wishlist-social');
    var status = wrapper ? wrapper.querySelector('[data-leaflock-wishlist-status]') : null;
    if (status) status.textContent = message || '';
  }

  function copyWishlistCaption(trigger) {
    var text = getWishlistShareText(trigger);
    var success = trigger.dataset.shareSuccess || 'Wishlist caption copied.';

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        writeWishlistStatus(trigger, success);
      }).catch(function () {
        writeWishlistStatus(trigger, text);
      });
      return;
    }

    writeWishlistStatus(trigger, text);
  }

  function shareWishlist(trigger) {
    copyWishlistCaption(trigger);
  }

  function bindWishlistSharing() {
    document.addEventListener('click', function (event) {
      var shareTrigger = event.target.closest('[data-leaflock-wishlist-share]');
      var copyTrigger = event.target.closest('[data-leaflock-wishlist-copy]');

      if (shareTrigger) {
        event.preventDefault();
        shareWishlist(shareTrigger);
      }

      if (copyTrigger) {
        event.preventDefault();
        copyWishlistCaption(copyTrigger);
      }
    });
  }

  function initDoseCalculator() {
    ensureDoseCalculatorMarkup();
    ensureDoseCalculatorLaunchers();

    var modal = document.getElementById('leaflock-dose-modal');
    if (!modal || modal.dataset.leaflockBound === 'true') return;

    modal.dataset.leaflockBound = 'true';

    var panel = modal.querySelector('.leaflock-dose-modal__panel');
    var lock = modal.querySelector('[data-leaflock-dose-lock]');
    var calculator = modal.querySelector('[data-leaflock-dose-calculator]');
    if (calculator && calculator.dataset.leaflockSimpleLayout !== 'true') {
      var logoImage = calculator.querySelector('.leaflock-dose-logo');
      var calculatorLogoUrl = logoImage && logoImage.getAttribute('src') ? logoImage.getAttribute('src') : '/cdn/shop/t/7/assets/leaflock-logo-main.png';
      calculator.innerHTML = buildDoseCalculatorHtml(calculatorLogoUrl);
      calculator.dataset.leaflockSimpleLayout = 'true';
    }

    var codeForm = modal.querySelector('[data-leaflock-dose-code-form]');
    var codeInput = modal.querySelector('#leaflock-dose-code');
    var codeError = modal.querySelector('[data-leaflock-dose-code-error]');
    var status = modal.querySelector('[data-leaflock-dose-status]');
    var warning = modal.querySelector('[data-leaflock-dose-warning]');
    var warningTitle = modal.querySelector('[data-leaflock-dose-warning-title]');
    var warningCopy = modal.querySelector('[data-leaflock-dose-warning-copy]');
    var range = modal.querySelector('[data-leaflock-dose-range]');
    var copyStatus = modal.querySelector('[data-leaflock-dose-copy-status]');
    var countWasEdited = false;
    var lastFocused = null;

    function ensureDoseCalculatorLaunchers() {
      var stockistLink = document.querySelector('.hdt-social-leaflock-stockist');
      if (stockistLink && stockistLink.closest('ul') && !stockistLink.closest('ul').querySelector('.hdt-social-leaflock-calculator')) {
        var item = document.createElement('li');
        item.className = 'hdt-socials__item hdt-inline-block';
        item.innerHTML = '<button type="button" class="hdt-social-leaflock-calculator hdt-flex hdt-align-center hdt-justify-center leaflock-dose-open" aria-label="LeafLock calculator"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 2v4h12V4H6Zm2 7v2h2v-2H8Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Zm-8 4v2h2v-2H8Zm4 0v2h2v-2h-2Zm4 0v5h2v-5h-2Zm-8 4v1h6v-1H8Z"/></svg><span class="sr-only">LeafLock calculator</span></button>';
        stockistLink.closest('li').insertAdjacentElement('afterend', item);
      }

      var stockistLounge = document.querySelector('.hdt-footer-lounge-icon-stockist');
      if (stockistLounge && stockistLounge.closest('ul') && !stockistLounge.closest('ul').querySelector('.leaflock-footer-calculator')) {
        var loungeItem = document.createElement('li');
        loungeItem.innerHTML = '<button type="button" class="hdt-footer-menu_item hdt-footer-lounge-item hdt-s-text2 leaflock-footer-calculator leaflock-dose-open"><span class="hdt-footer-lounge-icon hdt-footer-lounge-icon-calculator"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 2v4h12V4H6Zm2 7v2h2v-2H8Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Zm-8 4v2h2v-2H8Zm4 0v2h2v-2h-2Zm4 0v5h2v-5h-2Zm-8 4v1h6v-1H8Z"/></svg></span><span>LeafLock calculator</span></button>';
        stockistLounge.closest('li').insertAdjacentElement('afterend', loungeItem);
      }
    }

    function ensureDoseCalculatorMarkup() {
      if (document.getElementById('leaflock-dose-modal')) return;

      var logoUrl = '/cdn/shop/t/7/assets/leaflock-logo-main.png';
      var wrapper = document.createElement('div');
      wrapper.innerHTML = '<div class="leaflock-dose-modal" id="leaflock-dose-modal" hidden><div class="leaflock-dose-modal__backdrop" data-leaflock-dose-close></div><section class="leaflock-dose-modal__panel" role="dialog" aria-modal="true" aria-labelledby="leaflock-dose-title" tabindex="-1"><button class="leaflock-dose-modal__close" type="button" data-leaflock-dose-close aria-label="Close calculator"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.4 4.2 12 10.6 5.6 4.2 4.2 5.6l6.4 6.4-6.4 6.4 1.4 1.4 6.4-6.4 6.4 6.4 1.4-1.4-6.4-6.4 6.4-6.4-1.4-1.4Z"/></svg></button><div class="leaflock-dose-lock" data-leaflock-dose-lock><img class="leaflock-dose-logo" src="' + logoUrl + '" alt="LeafLock" width="260" height="90" loading="lazy"><p class="leaflock-dose-kicker">Private LeafLock tool</p><h2 id="leaflock-dose-title">Gummy batch calculator</h2><p class="leaflock-dose-copy">Enter the access code to open the calculator.</p><form class="leaflock-dose-code-form" data-leaflock-dose-code-form><label class="sr-only" for="leaflock-dose-code">Access code</label><input id="leaflock-dose-code" type="password" inputmode="numeric" autocomplete="off" placeholder="Access code"><button type="submit">Unlock</button></form><p class="leaflock-dose-code-hint">Code: 420420</p><p class="leaflock-dose-code-error" data-leaflock-dose-code-error role="status" aria-live="polite"></p></div><div class="leaflock-dose-calculator" data-leaflock-dose-calculator hidden><header class="leaflock-dose-head"><div><img class="leaflock-dose-logo leaflock-dose-logo--small" src="' + logoUrl + '" alt="LeafLock" width="190" height="66" loading="lazy"><p class="leaflock-dose-kicker">Recipe batch estimate</p><h2>Gummy batch calculator</h2></div><p>Educational estimate only. For lawful ingredients only. Follow product labels and local laws; this is not medical, legal, or safety advice.</p></header><div class="leaflock-dose-grid"><form class="leaflock-dose-form" data-leaflock-dose-form><div class="leaflock-dose-field"><label for="leaflock-dose-oil-strength">Oil strength</label><div class="leaflock-dose-input"><input id="leaflock-dose-oil-strength" data-leaflock-dose-field="oilStrength" type="number" value="100" min="0" step="1" inputmode="decimal"><span>mg/mL</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="oilStrength" data-value="25">25</button><button type="button" data-leaflock-dose-preset="oilStrength" data-value="50">50</button><button type="button" data-leaflock-dose-preset="oilStrength" data-value="100" class="is-active">100</button></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-bottle-size">Bottle size</label><div class="leaflock-dose-input"><input id="leaflock-dose-bottle-size" data-leaflock-dose-field="bottleSize" type="number" value="30" min="0" step="1" inputmode="decimal"><span>mL</span></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-target">Target per piece</label><div class="leaflock-dose-input"><input id="leaflock-dose-target" data-leaflock-dose-field="desiredPerGummy" type="number" value="10" min="0" step="1" inputmode="decimal"><span>mg</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="5">5</button><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="10" class="is-active">10</button><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="25">25</button></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-volume">Mould cavity</label><div class="leaflock-dose-input"><input id="leaflock-dose-volume" data-leaflock-dose-field="gummyVolume" type="number" value="2" min="0" step="0.1" inputmode="decimal"><span>mL</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="gummyVolume" data-value="2" class="is-active">2</button><button type="button" data-leaflock-dose-preset="gummyVolume" data-value="3">3</button><button type="button" data-leaflock-dose-preset="gummyVolume" data-value="5">5</button></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-count">Finished pieces</label><div class="leaflock-dose-input"><input id="leaflock-dose-count" data-leaflock-dose-field="gummyCount" type="number" value="80" min="1" step="1" inputmode="numeric"><span>pcs</span></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-total-oil">Final oil blend</label><div class="leaflock-dose-input"><input id="leaflock-dose-total-oil" data-leaflock-dose-field="totalOilVol" type="number" value="30" min="0" max="40" step="1" inputmode="decimal"><span>mL</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="totalOilVol" data-value="20">20</button><button type="button" data-leaflock-dose-preset="totalOilVol" data-value="30" class="is-active">30</button><button type="button" data-leaflock-dose-preset="totalOilVol" data-value="40">40</button></div></div></form><aside class="leaflock-dose-results" aria-live="polite"><div class="leaflock-dose-status" data-leaflock-dose-status>Ready to calculate</div><div class="leaflock-dose-result-main"><small>Oil volume to add</small><strong><span data-leaflock-dose-output="ingredientOilMl">8.00</span> mL</strong></div><div class="leaflock-dose-metrics"><div><small>Carrier oil to add</small><strong><span data-leaflock-dose-output="carrierMl">22.00</span> mL</strong></div><div><small>Total active amount</small><strong><span data-leaflock-dose-output="totalActiveMg">800</span> mg</strong></div><div><small>Bottle used</small><strong><span data-leaflock-dose-output="bottlePercent">26.7</span>%</strong></div><div><small>Bottles required</small><strong><span data-leaflock-dose-output="bottlesRequired">0.27</span></strong></div><div><small>Blend strength</small><strong><span data-leaflock-dose-output="blendStrength">26.7</span> mg/mL</strong></div><div><small>One bottle estimate</small><strong><span data-leaflock-dose-output="maxPerBottle">37.5</span> mg</strong></div></div><p class="leaflock-dose-range" data-leaflock-dose-range>Expected range: roughly 60-90 gummies using a 2 mL mould.</p><div class="leaflock-dose-warning" data-leaflock-dose-warning hidden><strong data-leaflock-dose-warning-title></strong><span data-leaflock-dose-warning-copy></span></div><p class="leaflock-dose-disclaimer">Educational estimate only. For lawful ingredients only. Not medical, legal, or safety advice. Follow product labels and local laws, label finished items clearly, and keep finished items away from children.</p><div class="leaflock-dose-actions"><button type="button" data-leaflock-dose-copy>Copy result</button><button type="button" data-leaflock-dose-reset>Reset</button></div><p class="leaflock-dose-copy-status" data-leaflock-dose-copy-status aria-live="polite"></p></aside></div></div></section></div>';
      document.body.appendChild(wrapper.firstElementChild);
    }

    function buildDoseCalculatorHtml(logoUrl) {
      return '<header class="leaflock-dose-head"><div><img class="leaflock-dose-logo leaflock-dose-logo--small" src="' + logoUrl + '" alt="LeafLock" width="190" height="66" loading="lazy"><p class="leaflock-dose-kicker">Batch estimate tool</p><h2>Gummy batch calculator</h2></div><p>Use this for general recipe math with lawful ingredients only. It estimates batch amounts from label strength and bottle size.</p></header><div class="leaflock-dose-grid"><form class="leaflock-dose-form" data-leaflock-dose-form><section class="leaflock-dose-card"><div class="leaflock-dose-card__head"><span>Step 1</span><h3>Label details</h3><p>Use the strength printed on your bottle or ingredient label.</p></div><div class="leaflock-dose-field-grid"><div class="leaflock-dose-field"><label for="leaflock-dose-oil-strength">Label strength</label><div class="leaflock-dose-input"><input id="leaflock-dose-oil-strength" data-leaflock-dose-field="oilStrength" type="number" value="100" min="0" step="1" inputmode="decimal"><span>mg/mL</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="oilStrength" data-value="25">25</button><button type="button" data-leaflock-dose-preset="oilStrength" data-value="50">50</button><button type="button" data-leaflock-dose-preset="oilStrength" data-value="100" class="is-active">100</button></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-bottle-size">Bottle size</label><div class="leaflock-dose-input"><input id="leaflock-dose-bottle-size" data-leaflock-dose-field="bottleSize" type="number" value="30" min="0" step="1" inputmode="decimal"><span>mL</span></div></div></div></section><section class="leaflock-dose-card"><div class="leaflock-dose-card__head"><span>Calculator 1</span><h3>What is in my batch?</h3><p>Use this when you already know the amount of oil added to the batch.</p></div><div class="leaflock-dose-field-grid"><div class="leaflock-dose-field"><label for="leaflock-dose-oil-used">Oil added to the batch</label><div class="leaflock-dose-input"><input id="leaflock-dose-oil-used" data-leaflock-dose-field="oilUsed" type="number" value="8" min="0" step="0.1" inputmode="decimal"><span>mL</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="oilUsed" data-value="5">5</button><button type="button" data-leaflock-dose-preset="oilUsed" data-value="8" class="is-active">8</button><button type="button" data-leaflock-dose-preset="oilUsed" data-value="10">10</button></div></div><div class="leaflock-dose-field"><label for="leaflock-dose-count">How many pieces are you making?</label><div class="leaflock-dose-input"><input id="leaflock-dose-count" data-leaflock-dose-field="gummyCount" type="number" value="80" min="1" step="1" inputmode="numeric"><span>pcs</span></div></div></div></section><section class="leaflock-dose-card"><div class="leaflock-dose-card__head"><span>Calculator 2</span><h3>Target amount per piece</h3><p>Enter the amount per piece you are calculating for. The result estimates the matching oil volume.</p></div><div class="leaflock-dose-field"><label for="leaflock-dose-target">Target amount per piece</label><div class="leaflock-dose-input"><input id="leaflock-dose-target" data-leaflock-dose-field="desiredPerGummy" type="number" value="10" min="0" step="1" inputmode="decimal"><span>mg</span></div><div class="leaflock-dose-quick"><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="5">5</button><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="10" class="is-active">10</button><button type="button" data-leaflock-dose-preset="desiredPerGummy" data-value="25">25</button></div></div></section></form><aside class="leaflock-dose-results" aria-live="polite"><div class="leaflock-dose-status" data-leaflock-dose-status>Ready to calculate</div><div class="leaflock-dose-result-main"><small>Oil volume for target amount</small><strong><span data-leaflock-dose-output="ingredientOilMl">8.00</span> mL</strong></div><div class="leaflock-dose-metrics"><div><small>Oil you entered</small><strong><span data-leaflock-dose-output="oilUsedOutput">8.00</span> mL</strong></div><div><small>Estimated amount each</small><strong><span data-leaflock-dose-output="usePerGummy">10.0</span> mg</strong></div><div><small>Total active amount</small><strong><span data-leaflock-dose-output="useTotalMg">800</span> mg</strong></div><div><small>Bottle used</small><strong><span data-leaflock-dose-output="bottlePercent">26.7</span>%</strong></div><div><small>Bottles required</small><strong><span data-leaflock-dose-output="bottlesRequired">0.27</span></strong></div><div><small>Bottle left</small><strong><span data-leaflock-dose-output="remainingBottle">22.00</span> mL</strong></div></div><p class="leaflock-dose-range" data-leaflock-dose-range>Calculator 1 estimates what is in the batch. Calculator 2 estimates the oil volume for a target amount.</p><div class="leaflock-dose-warning" data-leaflock-dose-warning hidden><strong data-leaflock-dose-warning-title></strong><span data-leaflock-dose-warning-copy></span></div><p class="leaflock-dose-disclaimer">Educational estimate only. For lawful ingredients only. Not medical, legal, or safety advice. Follow product labels and local laws, label finished items clearly, and keep finished items away from children.</p><div class="leaflock-dose-actions"><button type="button" data-leaflock-dose-copy>Copy result</button><button type="button" data-leaflock-dose-reset>Reset</button></div><p class="leaflock-dose-copy-status" data-leaflock-dose-copy-status aria-live="polite"></p></aside></div>';
    }

    function value(name) {
      var field = modal.querySelector('[data-leaflock-dose-field="' + name + '"]');
      return field ? Number(field.value) || 0 : 0;
    }

    function output(name, text) {
      var node = modal.querySelector('[data-leaflock-dose-output="' + name + '"]');
      if (node) node.textContent = text;
    }

    function estimateYield(volume) {
      if (!volume) return 80;
      return Math.max(1, Math.round(160 / volume));
    }

    function setStatus(text, isWarning) {
      if (!status) return;
      status.textContent = text;
      status.classList.toggle('is-warning', Boolean(isWarning));
    }

    function setWarning(title, copy) {
      if (!warning || !warningTitle || !warningCopy) return;
      warningTitle.textContent = title || '';
      warningCopy.textContent = copy || '';
      warning.hidden = !title && !copy;
    }

    function updatePresetState(fieldName, selectedValue) {
      modal.querySelectorAll('[data-leaflock-dose-preset="' + fieldName + '"]').forEach(function (button) {
        button.classList.toggle('is-active', Number(button.dataset.value) === Number(selectedValue));
      });
    }

    function calculateDose() {
      var oilStrength = value('oilStrength');
      var bottleSize = value('bottleSize');
      var desiredPerGummy = value('desiredPerGummy');
      var gummyCount = Math.round(value('gummyCount'));
      var oilUsed = value('oilUsed');
      var outputs = ['ingredientOilMl', 'oilUsedOutput', 'usePerGummy', 'useTotalMg', 'bottlePercent', 'bottlesRequired', 'remainingBottle'];

      setWarning('', '');

      if (oilStrength <= 0 || bottleSize <= 0 || desiredPerGummy <= 0 || gummyCount <= 0 || oilUsed <= 0) {
        outputs.forEach(function (name) {
          output(name, '-');
        });
        if (range) range.textContent = 'Enter valid numbers to calculate your batch.';
        setStatus('Check inputs', true);
        return;
      }

      var useTotalMg = oilStrength * oilUsed;
      var usePerGummy = useTotalMg / gummyCount;
      var desiredTotalMg = desiredPerGummy * gummyCount;
      var oilNeeded = desiredTotalMg / oilStrength;
      var bottlesRequired = oilNeeded / bottleSize;
      var bottlePercent = bottlesRequired * 100;
      var remainingBottle = Math.max(0, bottleSize - oilNeeded);

      output('ingredientOilMl', oilNeeded.toFixed(2));
      output('oilUsedOutput', oilUsed.toFixed(2));
      output('usePerGummy', usePerGummy.toFixed(1));
      output('useTotalMg', useTotalMg.toFixed(0));
      output('bottlePercent', bottlePercent.toFixed(1));
      output('bottlesRequired', bottlesRequired.toFixed(2));
      output('remainingBottle', remainingBottle.toFixed(2));

      if (range) {
        range.textContent = 'If you use ' + oilUsed.toFixed(2) + ' mL, each gummy is about ' + usePerGummy.toFixed(1) + ' mg. For ' + desiredPerGummy.toFixed(1) + ' mg each, use ' + oilNeeded.toFixed(2) + ' mL.';
      }

      setStatus('Ready to calculate', false);

      if (oilUsed > bottleSize) {
        setWarning('Oil amount is bigger than one bottle.', 'You entered ' + oilUsed.toFixed(2) + ' mL, but the bottle size is ' + bottleSize.toFixed(2) + ' mL. Check the oil amount or bottle size.');
        setStatus('Check bottle size', true);
        return;
      }

      if (bottlesRequired > 1) {
        setWarning('More than one bottle is required.', 'For the target amount, this estimates ' + oilNeeded.toFixed(2) + ' mL, equal to ' + bottlesRequired.toFixed(2) + ' bottles of ' + bottleSize.toFixed(0) + ' mL.');
        setStatus('Needs more than 1 bottle', true);
        return;
      }
    }

    function showCalculator() {
      modal.dataset.unlocked = 'true';
      if (lock) lock.hidden = true;
      if (calculator) calculator.hidden = false;
      window.sessionStorage.setItem('leaflockDoseUnlocked', 'true');
      calculateDose();
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('leaflock-dose-open');

      if (window.sessionStorage.getItem('leaflockDoseUnlocked') === 'true') {
        showCalculator();
      } else {
        if (lock) lock.hidden = false;
        if (calculator) calculator.hidden = true;
        if (codeInput) {
          codeInput.value = '';
          window.setTimeout(function () {
            codeInput.focus();
          }, 50);
        }
      }

      if (panel) {
        window.setTimeout(function () {
          panel.focus();
        }, 60);
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('leaflock-dose-open');
      if (codeError) codeError.textContent = '';
      if (copyStatus) copyStatus.textContent = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function resetDose() {
      var defaults = {
        oilStrength: 100,
        bottleSize: 30,
        oilUsed: 8,
        gummyCount: 80,
        desiredPerGummy: 10
      };

      Object.keys(defaults).forEach(function (name) {
        var field = modal.querySelector('[data-leaflock-dose-field="' + name + '"]');
        if (field) field.value = defaults[name];
        updatePresetState(name, defaults[name]);
      });

      countWasEdited = false;
      if (copyStatus) copyStatus.textContent = '';
      calculateDose();
    }

    function copyDose() {
      var text = 'LeafLock gummy batch estimate\n' +
        'Oil strength: ' + value('oilStrength') + ' mg/mL\n' +
        'Bottle size: ' + value('bottleSize') + ' mL\n' +
        'Pieces: ' + value('gummyCount') + '\n' +
        'Oil added: ' + value('oilUsed') + ' mL\n' +
        'Estimated amount each: ' + (modal.querySelector('[data-leaflock-dose-output="usePerGummy"]') || {}).textContent + ' mg\n' +
        'Target amount each: ' + value('desiredPerGummy') + ' mg\n' +
        'Oil volume estimate: ' + (modal.querySelector('[data-leaflock-dose-output="ingredientOilMl"]') || {}).textContent + ' mL\n' +
        'Educational estimate only. For lawful ingredients only. Not medical, legal, or safety advice.\n' +
        window.location.origin;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          if (copyStatus) copyStatus.textContent = 'Result copied.';
        }).catch(function () {
          if (copyStatus) copyStatus.textContent = text;
        });
      } else if (copyStatus) {
        copyStatus.textContent = text;
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.leaflock-dose-open');
      if (!trigger) return;

      event.preventDefault();
      openModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-leaflock-dose-close]')) {
        event.preventDefault();
        closeModal();
      }

      var preset = event.target.closest('[data-leaflock-dose-preset]');
      if (preset) {
        var fieldName = preset.dataset.leaflockDosePreset;
        var field = modal.querySelector('[data-leaflock-dose-field="' + fieldName + '"]');
        if (field) {
          field.value = preset.dataset.value;
          updatePresetState(fieldName, preset.dataset.value);
          if (fieldName === 'gummyVolume') {
            var countField = modal.querySelector('[data-leaflock-dose-field="gummyCount"]');
            if (countField && !countWasEdited) countField.value = estimateYield(Number(preset.dataset.value));
          }
          calculateDose();
        }
      }

      if (event.target.closest('[data-leaflock-dose-reset]')) {
        event.preventDefault();
        resetDose();
      }

      if (event.target.closest('[data-leaflock-dose-copy]')) {
        event.preventDefault();
        copyDose();
      }
    });

    modal.querySelectorAll('[data-leaflock-dose-field]').forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.dataset.leaflockDoseField === 'gummyCount') countWasEdited = true;
        updatePresetState(field.dataset.leaflockDoseField, field.value);
        calculateDose();
      });
    });

    if (codeForm) {
      codeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var normalized = codeInput ? codeInput.value.replace(/\D/g, '') : '';

        if (normalized.indexOf('420') !== -1) {
          if (codeError) codeError.textContent = '';
          showCalculator();
          return;
        }

        if (codeError) codeError.textContent = 'That code did not unlock the calculator.';
      });

      var unlockButton = codeForm.querySelector('button');
      if (unlockButton) {
        unlockButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (codeForm.requestSubmit) {
            codeForm.requestSubmit();
          } else {
            codeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
      }
    }

    document.addEventListener('keydown', function (event) {
      if (modal.hidden || event.key !== 'Escape') return;
      closeModal();
    });

    calculateDose();
  }

  window.addEventListener('load', function () {
    tuneMappyStoreList();
    watchMappyStoreList();
    initSmartBundles();
    enhanceWishlistSharingPanel();
    bindWishlistSharing();
    initDoseCalculator();
  });
})();
